<template>
  <div class="answer">
    <div class="answer-box">
      <div class="answer-tit">{{ currentQuestion.title }}</div>
      <div class="answer-cont">
        <div
          @click="selectQuestion(index)"
          v-for="(item, index) in currentQuestion.result"
          :key="index"
          class="answer-item"
          :class="{ active: item.active,error:item.error,right:item.right }"
        >
          <div class="answer-item-con">
            {{ item.label }}
          </div>
        </div>
      </div>
      <!-- <p class="answer-des">*请在倒计时结束前答题哦。</p> -->
      <div v-if="currentIndex<questions.length-1"
        @click="setNext"
        class="answer-submit label"
      >
        <div>
            {{ getBtnText() }}
            <div class="answer-step MazdaTypeRegular">
              {{ currentIndex + 1 }}/{{ questions.length }}
            </div>
        </div>
      </div>
      <div v-if="currentIndex==questions.length-1"
        @click="lookScore"
        class="answer-submit label"
      >
        {{checkHasError ? '继续努力明天再来' : '太棒了，返回抽奖'}}
        <div class="answer-step">
          {{ currentIndex + 1 }}/{{ questions.length }}
        </div>
      </div>
      <!-- <div class="answer-clock">
          <img src="https://picbed.qunarzz.com/e4e4e14d54c34a3abc9927b85d271501.png" alt="">
          <span class="answer-clock-num">{{time}}</span>
      </div> -->
    </div>
  </div>
</template>

<script>
import loginDialog from "../dialog/login/index";
import createAudio from './audio'
export default {
  props: ["mode"],
  data() {
    return {
      modeList: {
        MENGXING_PATTERN:
          "https://picbed.qunarzz.com/dea304bbd37d4fda5ff3a27e9eac0c97.png",
        HANMI_PATTERN:
          "https://picbed.qunarzz.com/dc8df32aa093f054b4eb1e021fd28058.png",
        DASHEN_PATTERN:
          "https://picbed.qunarzz.com/9020f58b9410be9c1bfae97b56e424d4.png",
      },
      questions: [],
      currentIndex: 0,
      currectCommit: 0,
      time:15,
      timer:null,
      loading:false,
      lookResult:false,
      currentQuestion: { title: "", result: [] },
    };
  },
  methods: {
    checkHasError(){
      let errorNum = 0;
      this.questions.forEach((item)=>{
        item.result.forEach((child)=>{
          if(child.error){
            errorNum++;
          }
        })
      })
      return errorNum > 0 ? true : false
    },
    setQuestions(questions) {
      /* 设置问题列表并且初始化 */
      this.currentIndex = 0;
      this.questions = [...questions];
      this.currentQuestion = questions[this.currentIndex];
      // this.time = 15;
      // this.setTimer();
    },
    close(){
      this.$emit('close')
    },
    setErrorAll(){
      this.currentQuestion.result.forEach((item,index)=>{
          item.error = true;
      })
    },
    setTimer(){
      this.timeRun().then(()=>{/* 过期的回调。如果过期把选项更新为错误选项 */
          this.submitQuestion(true);
      })
    },
    timeRun(){
      return new Promise((resolve)=>{
          if(this.timer)return;
          this.timer = setInterval(()=>{
              this.time--;
              if(this.time == 0){
                  clearInterval(this.timer);
                  this.timer = null;
                  resolve();
              }
          },1000)
      })
    },
    getBtnText() {
      return "下一题";
    },
    setNext() {
      if (!this.judgeIfSubmit()) {
        this.$dialog.alert({
          message: '请选择',
        });
        return;
      }
      this.setNextQuestion();
    },
    submit(){
      this.submitQuestion();
    },
    getParams(isOutTime) {
      var params = {};
      if(isOutTime){
        params.topicRecordId = this.currentQuestion.result[0].parentId;
        params.optionsId = '';
      }else{
        this.currentQuestion.result.forEach((item, index) => {
          if (item.active) {
            params.topicRecordId = item.parentId;
            params.optionsId = item.id;
          }
        });
      }
      return params;
    },
    resetAnswer() {
      this.currectCommit = 0;
      this.questions = [];
      this.lookResult = false;
      this.currentIndex = 0;
      this.currentQuestion = { title: "", result: [] };
    },
    submitQuestion(isOutTime) {
      if(this.loading)return;
      let params = this.getParams(isOutTime);
      this.loading = true;
      this.$axios.post("/changmatwo/answer", params).then((res) => {
        this.loading = false;
        if (res.code == 400) {
          loginDialog({
            callback: () => {
              this.submitQuestion(isOutTime);
            },
          });
        } else if (res.code == 200) {
          var isRight = false;
          if (res.data.correct) {
            this.currectCommit++;
          }
          this.currentQuestion.result.forEach((item,index)=>{
              if(isOutTime){
                  if(item.id == res.data.correctId){
                    this.$set(item,'right',true);
                  }
                  isRight = false;
              }else{
                  if(!res.data.correct){
                      isRight = false;
                      if(res.data.correctId == params.optionsId){
                          if(item.id == params.optionsId){
                              this.$set(item,'right',true);
                          }
                      }else{
                          if(item.id == res.data.correctId){
                            this.$set(item,'right',true);
                          }
                          if(item.id == params.optionsId){
                              item.error = true;
                          }
                      }
                  }else{
                      if(item.id == params.optionsId){
                          isRight = true;
                          this.$set(item,'right',true);
                      }
                  }
              }
          })
          if (this.currentIndex < this.questions.length - 1) {
              if(isRight){
                createAudio('right');
              }else{
                createAudio('error');
              }
          }
          // clearInterval(this.timer);
          // this.timer = null;
          // let timer = setTimeout(()=>{
          //     clearTimeout(timer);
          //     timer = null;
          //     this.setNextQuestion();
          // },1000)
          
        } else {
          this.$dialog.alert({
            message: res.message,
          });
        }
      });
    },
    setNextQuestion() {
      this.time = 15;
      if (this.currentIndex < this.questions.length - 1) {
          this.currentIndex++;
          this.currentQuestion = this.questions[this.currentIndex];
          // this.setTimer();
      }else{
          this.lookResult = true;
      }
    },
    lookScore(){
      if (!this.judgeIfSubmit()) {
        this.$dialog.alert({
          message: '请选择',
        });
        return;
      }
      this.close();
    },
    judgeSelected() {
      var selected = false;
      this.currentQuestion.result.forEach((item, idx) => {
        if (item.active) {
          selected = true;
        }
      });
      return selected;
    },
    judgeIfSubmit() {
      let isSubmit = false;
      this.currentQuestion.result.forEach((item, idx) => {
        if(item.isSubmit){
            isSubmit = true;
        }
      });
      return isSubmit;
    },
    selectQuestion(index) {
      let isSubmit = false;
      this.currentQuestion.result.forEach((item, idx) => {
        if(item.isSubmit){
            isSubmit = true;
        }
      });
      if(!isSubmit){
          this.currentQuestion.result.forEach((item, idx) => {
            if (index == idx) {
              item.active = true;
              item.isSubmit = true;
            } else {
              item.active = false;
            }
          });
          this.submit();
      }
    },
  },
};
</script>

<style lang="less" scoped="true">
@font-face {
  font-family: "MazdaTypeRegular";
  src: url("../../MazdaTypeRegular.otf");
}
.MazdaTypeRegular{
  font-family: "MazdaTypeRegular";
}
.answer {
  position: relative;
  &-head{
    width:286px;
    margin-left:auto;
    margin-right:auto;
    text-align: center;
    padding-bottom:16px;
    color: rgba(69, 98, 116, 1);
    font-size:16px;
    border-bottom: 1px solid;
    border-image: linear-gradient(-90deg, #F5E9DE, #E3CEBD) 10 10;
    box-shadow: 0px 0px 0px 0px rgba(137, 146, 152, 0.85);
  }
  &-box {
    min-height: 440px;
    border-radius: 3px;
    padding-top: 31px;
    box-sizing: border-box; 
  }
  .answer-des{
    color:#fff511;
    padding-top:8px;
    padding-bottom: 8px;
  }
  &-tit {
    color: #fff;
    font-size: 15px;
    text-align: center;
    margin-top:16px;
    margin-bottom:23px;
    width: 315px;
    margin-left: auto;
    margin-right: auto;
  }
  &-item {
    width: calc(100% - 52px);
    border: 1px solid #CED8EA;
    background-color: transparent;
    border-radius: 17px;
    margin-bottom: 15px;
    color: #fff;
    font-size: 17px;
    position: relative;
    &.error{
      background-color: #9B9B9B;
    }
    &.right{
      background-color: #BA3737;
      box-shadow: 0px 3px 5px 0px rgb(217 67 67 / 30%);  
    }
    &.error:before{
      content:"";
      display: block;
      width: 12px;
      height: 12px;
      background:url(https://s.qunarzz.com/srmweb/qunaradv/changma_xc/15.png) no-repeat;
      background-size:100% auto;
      position: absolute;
      right: 10px;
      top: 10px;
    }
    &.right:before{
      content:"";
      display: block;
      width:16px;
      height:16px;
      background:url(https://s.qunarzz.com/srmweb/qunaradv/changma_xc/2.png) no-repeat;
      background-size:100% auto;
      position: absolute;
      right: 10px;
      top: 10px;
    }
    // &.active:before{
    //   content:"";
    //   display: block;
    //   width:20px;
    //   height:20px;
    //   background:url(https://picbed.qunarzz.com/8bce1075474afe1b410748e5ee637281.png) no-repeat;
    //   background-size:100% auto;
    //   position: absolute;
    //   right: 10px;
    //   top: 6px;
    // }
    text-align: center;
    height:32px;
    line-height:32px;
    margin-left: auto;
    margin-right: auto;
    &-con {
      width: 231px;
      font-size:13px;
      display: inline-block;
      text-align: left;
      margin-left: auto;
      margin-right: auto;
    }
  }
  &-submit {
    width: 243px;
    height: 33px;
    color: #fff;
    font-size: 16px;
    line-height: 33px;
    text-align: center;
    background-color: #BA3737;
    position: absolute;
    bottom: 0;
    left: 50%;
    margin-left: -121px;
    display: flex;
    border-radius: 20px;
    align-items: center;
    justify-content: center;
    >div{
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .answer-step {
    color:#fff;
    margin-left:15px;
  }
}
.mode {
  position: absolute;
  left: 257px;
  top: 120px;
  height: 30px;
}
.answer-clock{
  position: absolute;
  bottom: -69px;
  width: 44px;
  left: 0;
  height:45px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  -webkit-box-align: center;
  img{
    position: absolute;
    left:0;
    top:0;
  }
}
.answer-clock-num{
  position: relative;
  font-size:16px;
}
</style>